import type { ReactNode, FC } from "react";

import * as _ from "lodash";
import styled from "styled-components";

const StyledLinkCell = styled.a<{ wordWrap: string; whiteSpace: string; width: string; color: string }>`
    display: inline-block;
    text-decoration: none;
    color: ${({ color }) => color};
    width: ${({ width }) => width};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: ${({ whiteSpace }) => whiteSpace};
    overflow-wrap: ${({ wordWrap }) => wordWrap};
`;

interface ILinkCellProps {
    href: string;
    target?: string;
    children?: ReactNode;
    className?: string;
    title?: string;
    value: number;
    onClick?: () => void;
    wordWrap?: string;
    whiteSpace?: string;
    width?: string;
    color?: string;
}

export const LinkCell: FC<ILinkCellProps> = ({
    href = "",
    target = "_self",
    value,
    onClick = _.noop,
    title,
    wordWrap = "unset",
    whiteSpace = "nowrap",
    width = "calc(100% - 15px)",
    color = "#1593e4",
}) => {
    return (
        <StyledLinkCell
            href={href}
            onClick={onClick}
            target={target}
            title={title}
            wordWrap={wordWrap}
            whiteSpace={whiteSpace}
            width={width}
            color={color}
        >
            {value}
        </StyledLinkCell>
    );
};

LinkCell.displayName = "LinkCell";
